<div class="row" class="mt-4" style="margin-bottom: 15px;">
  <div class="col-lg-9" *ngIf="rawData.length > 0">
    <kendo-grid
      #pivotGrid
      id='grid'
      [data]="gridData"
      [loading]="loading"
      [resizable]="true"
      [pageable]="false"
      [sortable]="{
        allowUnsort: true,
        mode: 'multiple'
      }"
      [sort]="gridState.sort"
      (sortChange)="gridSortChange($event)"
      [filterable]="false"
      (dataStateChange)="gridDataStateChange($event)"
      (excelExport)="onGridExport($event)"
    >
      <ng-template kendoGridToolbarTemplate *ngIf="canExport(false)">
        <button type="button" kendoGridExcelCommand icon="file-excel">
          Export to Excel
        </button>
      </ng-template>
      <kendo-grid-column
        field="indication"
        title="Indication"
        [width]="175"
        [locked]="true"
      >
        <ng-template kendoGridHeaderTemplate let-dataItem>
          <span style="color: white;">Indication</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        format="{0:n}"
        field="recordCount"
        title="Record Count"
        [width]="125"
        [locked]="true"
      >
        <ng-template kendoGridHeaderTemplate let-dataItem>
          <span style="color: white;">Record Count</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngFor="let column of gridColumns"
      field="{{ column.field }}"
      title="{{ column.title }}"
      format="{0:n}" [width]="125">
        <ng-template
          kendoGridHeaderTemplate
          let-column
          let-columnIndex="columnIndex"
        >
          <span style="color: white;">{{ column.title }}</span>
        </ng-template>
      <ng-template kendoGridFooterTemplate let-column>
        {{sumGridFooter(column.field)}}
      </ng-template>
      </kendo-grid-column>
      <kendo-grid-excel
        fileName="{{ exportFileName }}"
        [fetchData]="allExportData"
      ></kendo-grid-excel>
    </kendo-grid>
  </div>
  <div class="col-lg-3"></div>
</div>
<app-ngx-loading-spinner [showLoadingSpinner]="loading"></app-ngx-loading-spinner>
